<template>
  <div class="full h-screen pa-10">
    <p class="text-center white--text text-h3">Games</p>
    <div class="d-flex justify-center gap-3">
      <router-link to="/game/raynor">
        <div class="card_game">
          <img
            src="../../assets/img/RainorView.png"
            class="thumbnail_game"
            alt=""
          />
          <p class="text-center font-weight-bold mb-0 title_game">Raynor</p>
        </div>
      </router-link>
      <router-link to="/game/smara">
        <div class="card_game">
          <img
            src="../../assets/img/SmaraView.png"
            class="thumbnail_game"
            alt=""
          />
          <p class="text-center font-weight-bold mb-0 title_game">Smara</p>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "GameList",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.card_game {
  width: 300px;
  padding: 8px;
  border-radius: 10px;
  background: white;
}
.thumbnail_game {
  width: 100%;
  height: auto;
  border-radius: 8px;
}
.gap-3 {
  gap: 15px;
}
.title_game {
  text-decoration: none !important;
  border: none;
  color: #23003a;
}
</style>
